import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { startWith, takeUntil } from 'rxjs/operators';

import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'input-phone',
  templateUrl: './input-phone.component.html',
  styleUrls: ['./input-phone.component.scss'],
})
export class InputPhoneComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() public fc: UntypedFormControl = new UntypedFormControl();
  @Input() public errors: IErrorForm = {};
  @Input() public id: string = 'phoneNumber';
  @Input() public label: string = 'LABELS.MOBILE_NUMBER';
  @Input() public helper: string;
  @Input() public isStretch: boolean = true;
  @Input() public isShowConfirmed: boolean;
  @Input() public isShowHelper: boolean = true;
  @Input() public required: boolean;
  @Input() public customClass: string;
  @Input() public preferredCountries: string[] = ['us'];
  @Input() public autocomplete: string | undefined;

  @ViewChild('telInput') public telInput: ElementRef;
  private inputElement: HTMLElement;

  public inputFormControl: UntypedFormControl = new UntypedFormControl();

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.fc.valueChanges.pipe(startWith(this.fc.value), takeUntil(this.destroy$)).subscribe((value) => {
      this.inputFormControl.patchValue(value);
    });

    // Sync disabled state from parent control
    this.fc.statusChanges.pipe(startWith(this.fc.status), takeUntil(this.destroy$)).subscribe(() => {
      if (this.fc.disabled) {
        this.inputFormControl.disable();
      } else {
        this.inputFormControl.enable();
      }
    });

    this.inputFormControl.valueChanges.pipe(startWith(this.inputFormControl.value), takeUntil(this.destroy$)).subscribe((value) => {
      if (value && typeof value === 'object' && value.hasOwnProperty('internationalNumber') && value.hasOwnProperty('number')) {
        const internationalNumber = (value.internationalNumber || '').replace(/(\s|-)*/g, '') || '';
        const number = (value.number || '').replace(/(\s|-)*/g, '') || '';
        const phoneNumber = internationalNumber || number || null;
        if (phoneNumber !== this.fc.value) {
          this.fc.patchValue(phoneNumber);
          this.fc.markAsTouched();
          return;
        }
      }
      if (!value && this.fc.value !== value) {
        this.fc.patchValue(value);
        this.fc.markAsTouched();
      }

      // #8199
      this.cdr.markForCheck();
    });
  }

  public ngAfterViewInit(): void {
    // #8126
    // remove this once the lib is removed OR https://github.com/webcat12345/ngx-intl-tel-input/pull/448 is merged
    this.inputElement = this.telInput.nativeElement.querySelector('input[type="tel"]');
    if (this.autocomplete !== undefined) {
      this.inputElement?.setAttribute('autocomplete', this.autocomplete);
    }
    this.inputElement?.addEventListener('blur', () => this.onBlurEvent());
  }

  public ngOnDestroy(): void {
    this.inputElement?.removeEventListener('blur', () => this.onBlurEvent());
    this.destroy$.next();
  }

  public onBlurEvent(): void {
    this.fc.markAsTouched();
  }
}
